enum FontFamily {
    mallory = 'kite-mallory',
    montserrat = 'montserrat',
    pingFangSC = 'kite-pingfang SC',
    jhenghei = 'kite-microsoft jhenghei',
    pingFangTC = 'kite-pingfang TC',
    yahei = 'kite-microsoft yahei',
    heiti = 'kite-heiti',
    tahoma = 'kite-tahoma',
    thonburi = 'kite-thonburi',
    msNeogothic = 'kite-ms neo gothic',
    appleSdGothicNeo = 'kite-apple SD gothic neo',
    malgun = 'kite-malgun gothic',
    yuGothic = 'kite-yu gothic',
    meiryo = 'kite-meiryo',
    hiragino = 'kite-hiragino sans',
    helvetica = 'Helvetica',
    helveticaNeue = 'Helvetica Neue',
    arial = 'Arial',
    sansSerif = 'sans-serif',
}

export default FontFamily;
